export default {
  'QUIZ/ANSWER_RESULT': () => { },
  BUTTON_CLICK: () => { },
}
